import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { AgentsRotationCriteriaRoutes } from '../../../routes/HomeRoutes/AgentsRotationCriteriaRoutes';

export const AgentsRotationCriteriaLayout = () => (
  <SwitchRoute routes={AgentsRotationCriteriaRoutes} />
);
